
import React, { useEffect, useState, useContext } from "react";
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Button,
  InputLabel,
} from "@material-ui/core";
import { Typography, AppBar, Toolbar } from "@material-ui/core";
import MaterialTable from 'material-table';

import Rating from '@material-ui/lab/Rating';
import useDebounce from "../../../../../../Components/debounce";

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Grid from "@material-ui/core/Grid";
import Box from '@material-ui/core/Box';
// import Cancellation from './Cancellation';
// import Objective from './Objective';
// import Stakeholder from './Stakeholder';
// import Timeline from './Timeline';
import Paper from "@material-ui/core/Paper";
import DataClient from '../../../../../../Service/general_data_service';
import CopyToClipboard from "../../../../../../Components/copy_to_clipboard";
import DataService from "../../../../../../Service";
import { useDispatch, useSelector } from "react-redux";
import CustomInput from "../../../../../../Components/CustomInput";
import { showSnackbar } from "../../../../../../Components/Snackbar/SnackbarActions";
import StarIcon from "@material-ui/icons/Star";

const useStyles = makeStyles((theme) => ({
  tabRoot: {

    '& .MuiTabs-flexContainer': {
      justifyContent: "flex-start"
    },
    '& .MuiTabs-indicator': {
      backgroundColor: "transparent"
    }
  },
  // tabs: {
  //   color: "#43425D",
  //   borderWidth: 1,
  //   borderStyle: "solid",
  //   borderColor: "#ddd",
  //   backgroundColor: "#E9E9F0",
  //   borderTopLeftRadius: 5,
  //   borderTopRightRadius: 5,
  //   marginRight: 10,
  //   fontSize: 14,
  //   minWidth: 130,
  //   textTransform: "capitalize",
  //   "&.Mui-selected": {

  //     color: sessionStorage.getItem('role') == 'admin' ? '#3B86FF' : '#981B1E',
  //     backgroundColor: "#fff",
  //   }
  // },
  overviewContainer: {
    position: 'sticky', top: 64, paddingTop: 40, background: '#fff', zIndex: 11
  },
  appBar: {
    backgroundColor: "#fff",
    color: '#232323',
    boxShadow: "0px 3px 6px #232323",
    marginBottom: '2rem'
  },
  elevationTable: {
    margin: '1px'
  },

  miTable: {
    '& .MuiToolbar-root': {
      '& .material-icons': {
        color: theme.palette.secondary.main
      }
    },
    '& .MuiTableBody-root': {
      '& .MuiTableCell-body': {
        padding: "10px 16px",
        lineHeight: "1.50",
        //adding for font and colour changes/
        fontSize: "16px",
        fontFamily: "Open Sans",
        '& .MuiIconButton-root': {
          padding: "0px 16px",
        }
      }
    },
  }
}));



function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box role="tabpanel" hidden={value !== index} id={`full-width-tabpanel-${index}`} aria-labelledby={`full-width-tab-${index}`} {...other}>
      {value === index && children}
    </Box>
  );
}

export default function Evaluation(props) {

  const classes = useStyles();
  const [pageData, setPageData] = React.useState([]);
  const [ctcUrl, setCtcUrl] = React.useState('');
  const [slugId, setSlugId] = React.useState('');
  const [value, setValue] = React.useState(0);
  const [loading, setLoading] = useState(false);
  const [CoachinRequest, setCrfSection] = useState([]);
  const [crfAnswers, setCrfAnswers] = useState([]);
  const dispatch = useDispatch();
  const sessionStorage = window.sessionStorage.getItem("slug");
  const [userData, setUserData] = useState();
  const [action, setAction] = useState(null);
  const [crfSectionId, setCrfSectionId] = useState("");
  const [currentSelection, setCurrentSelection] = useState({});

  const [assignmentId, setAssignmentId] = useState("");
  const [crfId, setCrfId] = useState('');
  const [EvaluationForm, setEvaluationForm] = useState([]);
  const [evaluationFormId, setEvaluationFormId] = useState("");
  const [evaluationSlug, setEvaluationSlug] = useState("");
  const [answerData, setAnswerData] = useState({});
  let quesArr = []
  const handleChange = (event, newValue) => {
    setValue(newValue);
    // CafFetch()
  };

  let sectionId = '';
  let crfFromId = ''
  function a11yProps(index, item) {
    sectionId = item.id;
    crfFromId = item.coaching_agreement_form_id;
    //   setCrfSectionId(item.id)
    //   setCrfFormId(item.coaching_request_form_id)
    return {
      id: `scrollable-auto-tab-${index}`,
      'aria-controls': `scrollable-auto-tabpanel-${index}`,
    };
  }

  const copyUrl = useSelector((state) => state.commonReducer)?.accessPermission?.assignmentDetail.caf.copyURL

  //   const tabArr = ["Stakeholders", "Timelines and Logistics", "Cancellation and Termination", "Objectives"]
  //   const tabPanelArr = [
  //     <Stakeholder tabIndex={value} pageData={pageData} assignment_id={props.location?.state?.currentAssignment?.id} parentCall={setValue} />,
  //     <Timeline tabIndex={value} pageData={pageData} assignment_id={props.location?.state?.currentAssignment?.id} parentCall={setValue} />,
  //     <Cancellation tabIndex={value} pageData={pageData} assignment_id={props.location?.state?.currentAssignment?.id} parentCall={setValue} />,
  //     <Objective tabIndex={value} assignment_id={props.location?.state?.currentAssignment?.id} parentCall={setValue} />
  //   ]

  const CafFetch = () => {
    DataService.getDirectData(`/evaluation_forms/view_evaluation_form?assignment_id=${props.location?.state?.currentAssignment?.id}`).then(
      (res) => {
        // if(res.success){
        // console.log(`res.id`, res.id)
        setCrfId(res?.evaluation_form?.id)
        setCtcUrl(res?.evaluation_form?.slug)
        window.sessionStorage.setItem('slug', res?.evaluation_form?.slug);
        let EvaluationForm = res?.evaluation_form?.evaluation_form_fields;
        setEvaluationForm(EvaluationForm);
        setAssignmentId(res?.evaluation_form?.assignment_id)
        localStorage.clear();
        // setLoading(false);
      }
    );
  };
  const setInputState = (inputStateValue, inputId) => {

    setAnswerData({ ...answerData, [inputId]: inputStateValue });
    setUserData({ ...userData, [inputId]: inputStateValue });
  };

  const handleSubmit = () => {
    for (var i in answerData) {
      quesArr.push({ evaluation_form_field_id: i, value: answerData[i], number_of_star: "" })
    }
    const statusData = {
      evaluation_form_id: crfId,
      assignment_id: assignmentId,
      evaluation_answers: JSON.stringify(quesArr),
    }
    DataService.createData(statusData, "evaluation_answers")
      .then((res) => {
        // CafFetch()

        if ((value + 1) < CoachinRequest.length) {

          setValue(value + 1)
          dispatch(showSnackbar("success", ["Success!"]));
        }
        dispatch(showSnackbar("success", ["Success!"]));
      })
      .catch((err) => {
        // setLoading(false);
        dispatch(showSnackbar("error", [["" + err.errors]]));
      });
  };

  const setRatingState = (inputStateValue, inputId) => {

    setAnswerData({ ...answerData, [inputId]: inputStateValue });
    setUserData({ ...userData, [inputId]: inputStateValue });
  };
  const [totalCount, setTotalCount] = useState(1000);
  const [searchText, setSearchText] = useState('');
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [searchTextSelect, handleSearchText] = useState(null);
  const [apiData, setApiData] = useState([]);
  const debouncedSearchText = useDebounce(searchTextSelect, 700);
  const [recievedDate, setRecievedDate] = useState("");

  useEffect(() => {
    CafFetch()
  }, []);

  const bulletPointsMaker = (formData) =>{
    const formFields = [...formData]
      const recordObj ={};
    formFields.forEach((el,ind)=>{
      if(el.question_type === "Q/A" && el.field_type === "text"){
         if(!recordObj[ind] && el.answer !==null && el.answer?.trim().length!==0 ){
           recordObj[ind] = el.answer;        
         }
      }
    })
   for(let i in recordObj){
    const element = recordObj[i];
    if(element?.split("\n").length>1){
      
        formFields[i].answer = <ul style={{padding:0,listStylePosition:"inside"}}>{element?.split("\n").map(el=>{    return el.trim().length >0 && <li >{el}</li>})}</ul>;
    } 
   }
return formFields;    
}


  const getData = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      // search_keyword: debouncedSearchText || null,
      assignment_id: props.location?.state?.currentAssignment?.id
    }
    DataService.getDirectData('/evaluation_forms/assignment_evaluation_form_summary', params).then((res) => {
      if (res) {       
        setApiData(bulletPointsMaker(res.evaluation_form.evaluation_form_details));
        setTotalCount(res.total_count)
        setEvaluationSlug(res.evaluation_form.slug)
        setRecievedDate(res.evaluation_form.evaluation_form_received_date)
      }
    }).catch((error) => console.log(error))
  };
  useEffect(() => {
    setLoading(true);
    getData();
  }, [page, pageSize, debouncedSearchText]);
  useEffect(() => {
    CafFetch()
  }, []);

  const columns = [

    {
      field: "question",
      cellStyle: {
       width:"50%"
    },
      title: <Typography variant="h2" component="span" style={{ textAlign: "left", fontWeight: "bold" }}>Question</Typography>
    },
    {
      field: "rating",
      cellStyle: {
        width:"25%"
     },
      title: <Typography variant="h2" component="span" style={{ textAlign: "left", fontWeight: "bold" }}>Response</Typography>,
      render: rowData => rowData.question_type === "rating" ? <Rating name="read-only" value={rowData.rating} readOnly /> : rowData.answer
    },
    {
      field: "comment",
      cellStyle: {
        width:"25%"
     },
      title: <Typography variant="h2" component="span" style={{ textAlign: "left", fontWeight: "bold" }}>Additional comments (if any) </Typography>,
      render: rowData => rowData.question_type === "rating" ? rowData.answer : ""

    },

  ];
  const options = {
    search: false,
    emptyRowsWhenPaging: false,
    searchFieldAlignment: 'right',
    total: totalCount,
    headerStyle: {
      fontWeight: '200',
      color: "#981B1E",

    },
    toolbar: false
    // page:page,
    // pageSize: pageSize,
  };
  console.log('totalCount', totalCount)
  return <>
    <Grid container direction="row" justify="center" alignItems="center">
      <Grid item xs={11} style={{ textAlign: "center" }} direction="row" justify="center" alignItems="center" className={classes.overviewContainer}>
        <AppBar position="static" className={classes.appBar} elevation={0}>
          <Toolbar>
            <Grid container direction="row" justify="left" alignItems="left" xs={12}>
              <Grid item xs={6}>
                <Typography variant="h1" style={{ color: "#4A4A4A" }}>
                  <Box textAlign="left" fontWeight="fontWeightBold">Evaluation form</Box>
                </Typography>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </Grid>
      {evaluationSlug && <Grid item xs={11}>
        <Box>
          <CopyToClipboard
            text={evaluationSlug}
            formName={'evaluation_form'}
          />
        </Box>
        <br /><br />

      </Grid>}

      <Grid item xs={11}>
        <div className={classes.elevationTable}>
          <Grid item xs={12} className={classes.miTable}>
            <MaterialTable
              // style={{ margin: '0 2px' }}
              title=""
              //   icons={tableIcons}
              data={apiData}
              page={page}
              columns={columns}
              // options={options}
              options={{
                // rowStyle: {
                //   borderBottom: 'none',
                // },
                // cellStyle: {
                //   borderBottom: 'none',
                // },
                // headerStyle: {
                //   color: '#3B86FF',
                //   marginTop: '10px',
                //   borderBottom: 'none',
                // },
                emptyRowsWhenPaging: false,
                actionsColumnIndex: -1,
                search: false,
                // actionsCellStyle: {
                //   borderBottom: 'none',
                // },
                pageSize: pageSize,
                total: totalCount,
                pageSizeOptions:[20,50,75,100],
            headerStyle: {
              position: "sticky",
              top: "0"
            },
            maxBodyHeight: "600px" 
              }}
              totalCount={totalCount}
              onChangePage={(page) => {
                setPage(page);
              }}
              onChangeRowsPerPage={(pageSize) => {
                setPageSize(pageSize);
              }}
              onSearchChange={(search) => {
                setSearchText(search);
              }}

            />
          </Grid>
        </div>

      </Grid>
    </Grid>
  </>



}



